import * as React from "react";
import {
  InputErrorParagraph,
  StyledInputWrapper,
} from "src/components/shared/Inputs/InputWrapper/InputWrapper.components";

interface Props {
  className?: string;
  label: string;
  name?: string;
  errorMessage?: string;
  withPlaceholder: boolean;
}

const InputWrapper: React.FunctionComponent<Props> = ({
  className,
  children,
  label,
  name,
  errorMessage,
  withPlaceholder,
}) => (
  <StyledInputWrapper
    withPlaceholder={withPlaceholder}
    error={!!errorMessage}
    className={`${className} 'form-input'`}>
    {label && <label htmlFor={name}>{label}</label>}
    {children}
    <InputErrorParagraph className="form-error">
      {errorMessage && errorMessage}
    </InputErrorParagraph>
  </StyledInputWrapper>
);

export default InputWrapper;
